import React from 'react';

// Returns the current hour (0-23) in UK local time, DST-aware, regardless of
// where the user's device is. Falls back to the local hour if Intl fails.
const getUkHour = (): number => {
  try {
    const hourStr = new Intl.DateTimeFormat('en-GB', {
      timeZone: 'Europe/London',
      hour: 'numeric',
      hour12: false
    }).format(new Date());
    const parsed = parseInt(hourStr, 10);
    return Number.isFinite(parsed) ? parsed : new Date().getHours();
  } catch {
    return new Date().getHours();
  }
};

const SleepingHorseEmptyState: React.FC = () => {
  const beforeAnalysis = getUkHour() < 7;

  const title = beforeAnalysis
    ? "Today's analysis is still running"
    : 'No qualifying picks today';

  const message = beforeAnalysis
    ? 'Check back shortly after 7am.'
    : 'Check back again tomorrow';

  return (
    <div className="no-races-container">
      <div className="no-races-content">
        <h2 className="no-races-title">{title}</h2>
        <p className="no-races-message">{message}</p>
        <img
          src="/sleeping_horse.png"
          alt="Sleeping horse"
          className="no-races-image"
        />
      </div>
    </div>
  );
};

export default SleepingHorseEmptyState;
